import { Modal, Box, Divider, TextButton, Typography, useMediaQuery } from 'bonfire-kindling';

const ConfirmationModal = ({
  title,
  subtitle,
  CancelButtonProps,
  ConfirmButtonProps,
  children,
  ...props
}) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Modal size={isMobile ? 'tiny' : 'medium'} {...props}>
      <Box sx={{ p: 4, textAlign: { xs: 'center', sm: 'left' } }}>
        <Typography component="h1" gutterBottom variant="h4">
          {title}
        </Typography>
        {subtitle && <Typography component="h2">{subtitle}</Typography>}
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'flex-end',
          p: 4,
        }}
      >
        <TextButton
          fullWidth={isMobile}
          variant="outlined"
          {...CancelButtonProps}
          sx={{
            mb: { xs: 2, sm: 0 },
            mr: { xs: 0, sm: 2 },
            ...CancelButtonProps?.sx,
          }}
        />
        <TextButton fullWidth={isMobile} {...ConfirmButtonProps} />
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
